import { Link } from 'react-router-dom';
import { useVnGoldPrices } from '@/hooks/useVnGoldPrices';

export default function Hero() {
  const { data, loading, isMockData } = useVnGoldPrices();
  const sjc = data.find((d) => d.type_code === 'SJL1L10');

  const buyPrice = sjc ? sjc.buy.toLocaleString('vi-VN') + 'đ' : loading ? 'Đang tải...' : 'Chưa có dữ liệu';
  const sellPrice = sjc ? sjc.sell.toLocaleString('vi-VN') + 'đ' : loading ? 'Đang tải...' : 'Chưa có dữ liệu';
  const changePct = sjc ? sjc.change_percent : 0;
  const isUp = changePct >= 0;

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20luxury%20golden%20metallic%20flowing%20waves%20on%20a%20deep%20black%20background%2C%20elegant%20premium%20financial%20investment%20concept%2C%20warm%20gold%20light%20reflections%2C%20dark%20sophisticated%20atmosphere%2C%20high%20detail%20cinematic%20lighting%2C%20minimal%20composition&width=1600&height=900&seq=hero-gold-abstract-1&orientation=landscape"
          alt="Nền vàng kim loại cao cấp Goldsbvvn"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/55 to-background-50"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 md:px-6 pt-20 md:pt-40 pb-10 md:pb-24 text-center">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/30 text-primary-300 text-xs font-semibold">
          <i className="ri-flashlight-line text-sm"></i>
          Giá vàng cập nhật liên tục 24/7
        </span>

        <h1 className="mt-4 md:mt-6 text-2xl md:text-5xl font-bold leading-tight text-foreground-950">
          Nền tảng <span className="text-gold-gradient">giao dịch vàng</span> hàng đầu
          <br className="hidden md:block" /> dành cho nhà đầu tư Việt
        </h1>

        <p className="mt-3 md:mt-5 text-sm md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
          Theo dõi giá vàng SJC, PNJ, DOJI theo thời gian thực. Giao dịch mua bán minh bạch, nạp rút tiền nhanh chóng và an toàn.
        </p>

        <div className="mt-5 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/giao-dich"
            className="w-full sm:w-auto px-7 py-3 rounded-md bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors gold-glow"
          >
            Bắt đầu giao dịch
          </Link>
          <Link
            to="/thi-truong"
            className="w-full sm:w-auto px-7 py-3 rounded-md border border-background-400 text-foreground-800 font-semibold text-sm hover:border-primary-500 hover:text-primary-300 whitespace-nowrap cursor-pointer transition-colors"
          >
            Xem bảng giá
          </Link>
        </div>

        <div className="mt-6 md:mt-10 inline-flex flex-wrap items-center justify-center gap-x-4 md:gap-x-6 gap-y-2 md:gap-y-3 px-4 md:px-5 py-3 md:py-4 rounded-xl bg-background-100/80 border border-background-200/60 backdrop-blur relative">
          {isMockData && (
            <div className="absolute -top-2.5 right-3 px-1.5 py-0.5 rounded bg-secondary-100/80 text-[10px] text-secondary-700 font-medium">
              <i className="ri-information-line mr-0.5"></i>
              Dữ liệu minh họa
            </div>
          )}
          <div className="text-left">
            <p className="text-[10px] md:text-xs text-foreground-600">Vàng SJC (mua)</p>
            <p className="text-base md:text-lg font-bold text-foreground-950 whitespace-nowrap">
              {loading ? (
                <span className="inline-flex items-center gap-1 text-foreground-500">
                  <i className="ri-loader-4-line animate-spin text-sm"></i>
                  Đang tải...
                </span>
              ) : (
                buyPrice
              )}
            </p>
          </div>
          <div className="w-px h-10 bg-background-300/60 hidden sm:block"></div>
          <div className="text-left">
            <p className="text-[10px] md:text-xs text-foreground-600">Vàng SJC (bán)</p>
            <p className="text-base md:text-lg font-bold text-foreground-950 whitespace-nowrap">
              {loading ? (
                <span className="inline-flex items-center gap-1 text-foreground-500">
                  <i className="ri-loader-4-line animate-spin text-sm"></i>
                  Đang tải...
                </span>
              ) : (
                sellPrice
              )}
            </p>
          </div>
          <div className="w-px h-10 bg-background-300/60 hidden sm:block"></div>
          <div className="text-left">
            <p className="text-[10px] md:text-xs text-foreground-600">Thay đổi hôm nay</p>
            <p className={`text-base md:text-lg font-bold whitespace-nowrap ${isUp ? 'text-emerald-500' : 'text-rose-500'}`}>
              {loading ? (
                <span className="text-foreground-500">--</span>
              ) : (
                <>
                  {isUp ? '+' : ''}{changePct.toFixed(2)}%
                </>
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}